import React, { Component } from 'react';
import { Modal, Button, Popup, Icon } from 'semantic-ui-react'
import moment from 'moment'
import DatePicker from 'react-datepicker'

class SignOffModal extends Component {
  constructor(props){
    super(props);

    this.state = {
      sign_off: this.props.sign_off,
      showDatePicker: false,
      user_name: '',
      user_email: '',
    }
  }

  componentWillReceiveProps = (nextProps) => {
    let user  = nextProps.user
    let profile = user ? user.profile : '';
    let user_name = `${profile ? profile.first_name : ''} ${profile ? profile.last_name : ''}`
    let user_email =  (user && user.email ? user.email : '')

    this.setState({
      sign_off: nextProps.sign_off,
      user_name: user_name,
      user_email: user_email
    })
  }

  onAdd = (evt) => {
    var new_sign_off = {
      name: this.state.user_name,
      email: this.state.user_email,
      role: "",
      date: new Date().toISOString().split('T')[0]
    }
    var sign_off = this.state.sign_off.concat(new_sign_off)
    this.setState({
      sign_off: sign_off
    }, ()=>{
      this.props.onUpdate(this.state.sign_off)
    })
  }

  onEdit = (evt, index) => {
    var sign_off = this.state.sign_off[index]

    switch (evt.target.name) {
      case "name":
        sign_off.name = evt.target.value;
        break;
      case "role":
        sign_off.role = evt.target.value;
        break;
      case "date":
        sign_off.date = evt.target.value;
        break;
      default:
    }

    this.state.sign_off[index] = sign_off
    this.setState({
      sign_off: this.state.sign_off
    })
  }

  onDelete = (evt, index) => {
    this.state.sign_off.splice(index, 1);
    this.setState({
      sign_off: this.state.sign_off
    })
    this.props.onUpdate(this.state.sign_off)
  }

  onBlur = (evt) => {
    this.props.onUpdate(this.state.sign_off)
  }

  onSave = () => {
    this.props.onSave()
    this.props.onClose()
  }

  onClose = () => {
    this.props.onClose()
    this.props.onReset()
    this.toggleCalendar(false)
  }

  toggleCalendar = (show) => {
    this.setState({showDatePicker: show})
  }

  onDateSelection = (date, index) => {
    var sign_off = this.state.sign_off[index]
    sign_off.date = moment(date).format("DD MMM YYYY");
    this.state.sign_off[index] = sign_off
    this.toggleCalendar(false)
  }

  signOff = (index, name, email) => {
    var sign_off = this.state.sign_off[index]
    sign_off.name = name;
    sign_off.email = email;
    this.state.sign_off[index] = sign_off
    this.setState({
      sign_off: this.state.sign_off
    }, ()=>{
      this.props.onUpdate(this.state.sign_off)
    })
  }

  canEdit = () => {
    return (this.props.isAdmin || this.props.permission.can_update)
  }

  render() {
    const { manager_sign_off, name, role, date, save_changes, add_sign_off } = this.props.translations
    const sign_off_text  = this.props.translations.sign_off
    const { user_name, user_email } = this.state
    const canEdit = this.canEdit()

    return (
      <Modal trigger={ this.props.trigger } size={ 'tiny' } open={ this.props.shown } onClose={ () => this.onClose() } closeOnDimmerClick={false}>
        <Modal.Header>{manager_sign_off}</Modal.Header>
        <Modal.Content>
          <div className="sign-off-container">
            <table className="sign-off">
              <thead>
                <tr>
                  <th>{name}</th>
                  <th className="role">{role}</th>
                  <th>{date}</th>
                  <th className="delete"></th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.sign_off &&
                this.state.sign_off.length > 0 &&
                this.state.sign_off.map((sign_off, index) => {
                  const isSignedOff = !(sign_off.name.length === 0)
                  const isEditor = (sign_off.name === user_name || sign_off.email === user_email)
                  const ableToEditCells = isSignedOff ? isEditor : canEdit
                  return (
                    <tr key={"sign_off" + index}>
                      <td className="details-column">
                        <span className="details-container">
                          {
                            sign_off.name && sign_off.name.length > 0 &&
                            <div className="name">{sign_off.name}</div>
                          }
                          {
                            sign_off.email && sign_off.email.length > 0 &&
                            <div className="email">({sign_off.email})</div>
                          }

                        </span>
                        { isSignedOff && ableToEditCells &&
                          <i aria-hidden="true" className="delete icon" onClick={(evt)=>this.signOff(index, '', '')}></i>
                        }
                        { !isSignedOff &&
                          <a className='plan-action'
                             onClick={ e => {
                               e.stopPropagation();
                               if(canEdit){ this.signOff(index, user_name, user_email) }
                             }}>
                             {sign_off_text}
                          </a>
                        }
                      </td>
                      <td className="role-column">
                        <input disabled={!ableToEditCells}
                               style={{backgroundColor:'transparent'}}
                               type="text"
                               name='role'
                               value={sign_off.role}
                               onChange={(evt) => this.onEdit(evt, index)}
                               onBlur={this.onBlur}/>
                      </td>
                      <td className="date">
                        <div className="sign-off-input-date">
                          <div className="text">{ sign_off.date.length > 0 && moment(sign_off.date).format("DD MMM YYYY") }</div>
                          { ableToEditCells &&
                            <div className="picker">
                              <Popup
                                open={this.state.showDatePicker === index}
                                trigger={ <Icon name='calendar alternate' link circular inverted bordered/> }
                                content= {
                                  <div>
                                    <DatePicker
                                      onChange={ (date) => this.onDateSelection(date, index) }
                                      inline
                                      showYearDropdown
                                      showMonthDropdown
                                      useShortMonthInDropdown
                                      yearDropdownItemNumber={3}
                                    />
                                  </div>
                                }
                                onOpen={ () => this.toggleCalendar(index) }
                                onClose={ () => this.toggleCalendar(false) }
                                on='click'
                                position="bottom left"
                                basic
                                hoverable
                                flowing
                              />
                            </div>
                          }
                        </div>
                      </td>
                      {(index < 3) || !ableToEditCells ? <td></td> :
                        <td className="delete">
                          <i className='trash alternate outline icon'
                             onClick={(evt) => this.onDelete(evt, index)} />
                        </td>
                      }
                    </tr>
                  )
                })
              }
              </tbody>
            </table>
            { canEdit &&
              <label className="new-sign-off" onClick={ this.onAdd }><i className='user plus icon' />&nbsp;{add_sign_off}</label>
            }
          </div>
        </Modal.Content>
        <Modal.Actions>
          { canEdit &&
            <Button
              color='teal'
              content={save_changes}
              fluid
              size='medium'
              className="new-plan-button"
              onClick={ () => this.onSave() } />
          }
        </Modal.Actions>
        <i className="delete icon" onClick={ () => this.onClose() }></i>
      </Modal>
    )
  }
}

export default SignOffModal



// WEBPACK FOOTER //
// ./src/components/sign_off_modal.js